const EpousesDetailsAdherentData = [
    {
        id: 1,
        prenom: 'Sophie Ndiaye',
        age: '28 ans'
    },
];

export default EpousesDetailsAdherentData;
